import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/app/hellojob-pro/src/app/tim-viec-lam/client.tsx");
